import React from 'react';
import { Card, CardText } from 'material-ui/Card';
import { List } from 'material-ui/List';
import { TextField, DateField, BooleanField } from 'admin-on-rest';
import CHUrlField from '../utils/CHUrlField'

import ToggleAdButton from './ToggleAdButton'

const styles = {
    card: { borderLeft: 'solid 4px #fd9512', flex: 1, marginLeft: '1em' },
    icon: { float: 'right', width: 50, height: 50, padding: 16, color: '#fd9512'},
	heading: { fontSize: 17 },
	date: { opacity: '0.6' },
	cardStyle : {
		width: '31%',
		minHeight: 200,
		marginRight: '2%',
		marginBottom: '1%',
		display: 'inline-block',
		verticalAlign: 'top'
	},
	descriptionStyle : {
		display: 'block',
		minHeight: 40,
		marginBottom: '15px',
		lineHeight: '22px', 
		fontSize: '110%' 
	},
	checkfield : {
		marginLeft: '0px',
		display: 'block',
		width: 25,	
	},
	dataField : {
		display: 'block',
		marginTop: '5px',
		marginBottom: '5px',	
	},
	dataFieldTitle : {
		display: 'block',
		marginBottom: '5px',
		marginTop: '12px',	
	},
	titleStyle : {
		color: '#284263',
		marginTop: '2px',	
	},
	cardText : {
		color: '#444',	
	}
	
};

export default ({ domains = [], nb, translate }) => (
  
        <List>
		    {domains.map(record =>
    			 <Card key={record.id} style={styles.cardStyle}>          
					<CardText style={styles.cardText}>
						<h2 style={styles.titleStyle}><TextField record={record} source="title" /></h2>
						
						<span style={styles.descriptionStyle}>{record.description}</span>
						
						
						
						<span style={styles.dataField}>
						<strong style={styles.dataFieldTitle}>Bezoekers per maand: </strong>
						{record.monthlyvisits_disp} 
						</span>
						
						<span style={styles.dataField}>
						<strong style={styles.dataFieldTitle}>Minimale CPC: </strong> 
						€ {record.minimum_cpc}
						</span>
						
						<span style={styles.dataField}>
							<strong style={styles.dataFieldTitle}>Website</strong>
							<CHUrlField source="website_url" record={record} source_disp="title" sortable={false} />
						</span>
						
						<ToggleAdButton record={record} />
						
					</CardText>           
				</Card>
            )}
        </List>
 );



// WEBPACK FOOTER //
// ./src/admin_ads/Domainsselector.js